import { convertToPoperdateTime } from "../../../utils/constants/functions";

export const LsqHeaders = () => [
  { field: "sl_no", headerName: "Sl No", width: 100 },
  { field: "leadTypeName", headerName: "Lead Type", width: 150, toolTipGetter: true },
  { field: "name", headerName: "Name", width: 220, toolTipGetter: true },
  { field: "email", headerName: "Email", width: 220, toolTipGetter: true },
  {
    field: "phone",
    headerName: "Contact",
    width: 180,
    renderCell: (params) => {
      const countryCode = params.row.country_code || "91";
      const phone = params.row.phone || "";

      return countryCode.startsWith("+") ? `${countryCode} ${phone}` : `+${countryCode} ${phone}`;
    },
    toolTipGetter: true,
  },
  { field: "lead_id", headerName: "Lead Id", width: 120, toolTipGetter: true },
  { field: "assigned_sro", headerName: "Assigned OGA", width: 250, toolTipGetter: true },
  { field: "assigned_cro", headerName: "Assigned CRO", width: 250, toolTipGetter: true },

  { field: "source", headerName: "Source", width: 150, toolTipGetter: true },
  { field: "sub_source", headerName: "Sub Source", width: 150, toolTipGetter: true },
  { field: "project", headerName: "Project", width: 200, toolTipGetter: true },

  //   { field: 'currentDepartmentName', headerName: 'Current Department', width: 270, toolTipGetter: true },
  //   { field: 'currentEmployeeName', headerName: 'Current Employee', width: 200, toolTipGetter: true },
  //   { field: 'createdByName', headerName: 'Created By ', width: 200, toolTipGetter: true },
  //   { field: 'updatedByName', headerName: 'Updated By ', width: 200, toolTipGetter: true },
  {
    field: "SourceCampaign",
    headerName: "Source Campaign",
    width: 180,
    renderCell: (params) => {
      const source = params.row.extra_context || {};
      const SourceCampaign = source.SourceCampaign || "";
      return SourceCampaign || "—";
    },
    toolTipGetter: true,
  },
  {
    field: "SourceMedium",
    headerName: "Source Medium",
    width: 180,
    renderCell: (params) => {
      const source = params.row.extra_context || {};
      const SourceMedium = source.SourceMedium || "";
      return SourceMedium || "—";
    },
    toolTipGetter: true,
  },
  { field: "currentStatusName", headerName: "Status", width: 200, toolTipGetter: true },
  {
    field: "created_at",
    headerName: "Created At",
    width: 180,
    renderCell: (params) => {
      const convertedtoPoperdateTime = convertToPoperdateTime(params.row.created_at);
      return convertedtoPoperdateTime || "—";
    },
    toolTipGetter: true,
  },
];
